import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.CARGOS].GET_CARGOS]: {
		url: '/company/:companyId/cargo/',
	},

	[ModulesConfigMap[ModulesMap.CARGOS].GET_CARGO]: {
		url: '/company/:companyId/cargo/:cargoId/',
	},

	[ModulesConfigMap[ModulesMap.CARGOS].GET_CARGO_PREVIEW]: {
		url: '/company/:companyId/cargo/:cargoId/preview/',
	},

	[ModulesConfigMap[ModulesMap.CARGOS].GET_CARGO_POPUP]: {
		url: '/company/:companyId/cargo/:cargoId/popup/',
	},


	[ModulesConfigMap[ModulesMap.CARGOS].CREATE_CARGO]: {
		url: '/company/:companyId/cargo/',
		requestOptions: {
			method: 'POST',
		},
	},

	[ModulesConfigMap[ModulesMap.CARGOS].PUT_CARGO]: {
		url: '/company/:companyId/cargo/:cargoId/',
		requestOptions: {
			method: 'PUT',
		},
	},

	[ModulesConfigMap[ModulesMap.CARGOS].PATCH_CARGO]: {
		url: '/company/:companyId/cargo/:cargoId/',
		requestOptions: {
			method: 'PATCH',
		},
	},

	[ModulesConfigMap[ModulesMap.CARGOS].DELETE_CARGO]: {
		url: '/company/:companyId/cargo/:cargoId/',
		requestOptions: {
			method: 'DELETE',
		},
	},

}